import React from 'react'
import PropTypes from 'prop-types'
import { List, Button, Badge } from 'antd'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  center: {
    textAlign: 'center',
  },
})

export default function AlertsRecipients({
  onManage,
  providers,
  bpRecipients,
}) {
  const classes = useStyles()

  const allRecipients = []

  if (providers && providers.length > 0) {
    providers.forEach(provider => {
      if (provider.firstName || provider.lastName || provider.email) {
        allRecipients.push({
          type: 'provider',
          cardiacDevices: true,
          bloodPressure: provider.canReceiveBpAlerts,
          display: `${provider.firstName} ${provider.lastName} <${provider.email}>`,
        })
      }
    })
  }

  if (bpRecipients) {
    const bpEmails = bpRecipients.split('\n').filter(email => email.trim())
    bpEmails.forEach(email => {
      const existingProvider = allRecipients.find(
        r => r.display && r.display.includes(email.trim()),
      )
      if (!existingProvider) {
        allRecipients.push({
          type: 'email',
          cardiacDevices: false,
          bloodPressure: true,
          display: email.trim(),
        })
      }
    })
  }

  return (
    <List
      bordered
      dataSource={allRecipients}
      footer={
        <div className={classes.center}>
          <Button type="link" onClick={onManage}>
            Manage
          </Button>
        </div>
      }
      renderItem={item => {
        const badges = []
        if (item.cardiacDevices) {
          badges.push(
            <Badge key="cardiac" color="blue" text="Cardiac Devices" />,
          )
        }
        if (item.bloodPressure) {
          badges.push(<Badge key="bp" color="green" text="Blood Pressure" />)
        }

        return (
          <List.Item>
            <div>
              <div>{item.display}</div>
              {badges.length > 0 && (
                <div style={{ marginTop: '4px', display: 'flex', gap: '8px' }}>
                  {badges}
                </div>
              )}
            </div>
          </List.Item>
        )
      }}
    />
  )
}

AlertsRecipients.defaultProps = {
  providers: [],
  bpRecipients: '',
}

AlertsRecipients.propTypes = {
  providers: PropTypes.arrayOf({}),
  bpRecipients: PropTypes.string,
  onManage: PropTypes.func.isRequired,
}
